import { connect } from 'react-redux';
import { RootState } from 'src/store/store';
import UnloadChooserPage from 'src/components/pages/unload-page/chooser-page/UnloadChooserPage';

const mapStateToProps = (state: RootState) => ({
    accessibleTools: state.Init.initData.associateDetails.accessibleTools
});

export default connect(mapStateToProps)(UnloadChooserPage);
